import "./src/shared/styles/global.css";

// На телефонах при перезагрузке страницы браузер восстанавливает старую
// позицию скролла ДО того, как ScrollScene успевает смонтироваться и запереть
// прокрутку (overflow: hidden). Компонент всегда стартует с scrollUnlocked =
// false — то есть с более короткого, «свёрнутого» состояния разметки — и
// экран замирает на восстановленной глубокой позиции, где уже нет контента:
// со стороны выглядит как пустой белый экран, пока свайп (он ловится кастомным
// touch-обработчиком в обход overflow: hidden) не продвинет сцены до разблокировки.
//
// Фикс — только для мобильной ширины (десктоп не трогаем): отключаем
// автоматическое восстановление скролла браузером и принудительно
// возвращаемся к началу страницы при каждой загрузке/перезагрузке.
export const onClientEntry = () => {
  if (typeof window === "undefined") return;
  if (!window.matchMedia("(max-width: 760px)").matches) return;

  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
  window.scrollTo(0, 0);
};
